var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-menu",
    {
      attrs: { right: "", "close-on-blur": "", width: "340px" },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "activator" }, slot: "activator" },
        [
          _c(
            "app-toolbar-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip"),
                  expression: "$ct('tooltip')",
                },
              ],
              staticClass: "gift-button",
            },
            [
              _c("w-fa", { staticClass: "gift-icon", attrs: { icon: "gift" } }),
              _vm.badgeCount > 0
                ? _c("div", { staticClass: "gift-badge" }, [
                    _vm._v(" " + _vm._s(_vm.badgeCount) + " "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-transition-slide-height", { attrs: { appear: "" } }, [
        _vm.open
          ? _c(
              "div",
              { staticClass: "gift-panel" },
              [
                _c(
                  "div",
                  { staticClass: "gift-header" },
                  [
                    _c("w-fa", { staticClass: "mr", attrs: { icon: "gift" } }),
                    _c("span", [_vm._v(_vm._s(_vm.$ct("title")))]),
                  ],
                  1
                ),
                _vm.loading
                  ? _c(
                      "div",
                      { staticClass: "gift-loading" },
                      [_c("w-progress-circular", { attrs: { small: "" } })],
                      1
                    )
                  : _vm.items.length > 0
                  ? [
                      _c(
                        "div",
                        { staticClass: "gift-list" },
                        _vm._l(_vm.items, function (item) {
                          return _c(
                            "div",
                            { key: item.key, staticClass: "gift-item" },
                            [
                              _c("div", { staticClass: "gift-item-main" }, [
                                _c("div", { staticClass: "gift-item-name" }, [
                                  _vm._v(" " + _vm._s(item.name) + " "),
                                ]),
                                _c("div", { staticClass: "gift-item-date" }, [
                                  _vm._v(" " + _vm._s(item.date) + " "),
                                ]),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "gift-badge-status",
                                  class: item.badgeClass,
                                },
                                [_vm._v(_vm._s(item.badgeText))]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "gift-footer",
                          on: {
                            click: function ($event) {
                              return _vm.goToReferrals()
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$ct("view-all")) + " "),
                          _c("w-fa", {
                            staticClass: "ml",
                            attrs: { icon: "arrow-right" },
                          }),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c("div", { staticClass: "gift-empty" }, [
                        _c(
                          "div",
                          { staticClass: "gift-reward" },
                          [
                            _c("w-fa", {
                              staticClass: "mr",
                              attrs: { icon: "coins" },
                            }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$ct("reward-highlight"))),
                            ]),
                          ],
                          1
                        ),
                        _c("p", [_vm._v(_vm._s(_vm.$ct("empty-intro")))]),
                        _c("p", { staticClass: "gift-empty-sub" }, [
                          _c("span", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: _vm.$ct("empty-sub"),
                                expression: "$ct('empty-sub')",
                              },
                            ],
                          }),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "gift-footer",
                          on: {
                            click: function ($event) {
                              return _vm.goToReferrals()
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$ct("invite-cta")) + " "),
                          _c("w-fa", {
                            staticClass: "ml",
                            attrs: { icon: "arrow-right" },
                          }),
                        ],
                        1
                      ),
                    ],
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }